function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   width: 100%;\n   max-width: ", ";\n   margin: 0 auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { math } from 'polished';
var OuterContentWrapper = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return "calc(".concat(theme.sizes.contentWidth, " + ").concat(math("2 * ".concat(theme.sizes.contentSidePadding)), ")");
});
export { OuterContentWrapper };